import { ButtonGroup, FormGroup, Input, Tooltip } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { Col, Label, Row } from "reactstrap";
import ColorPickerFacade from "../../../../components/ColorPickerFacade/ColorPickerFacade";
import JirangoSwitch from "../../../../components/JirangoSwitch/JirangoSwitch";
import {
  deepClone,
  getValueFromNestedObject,
  setValueToNestedObject,
} from "../../../../helpers/objectHelper";
import { templateActions } from "../../../../store/actions/cms/template/template.action";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import EditorSlider from "../../../../components/EditorSlider/EditorSlider";
import UrlMultiInput from "../../../../components/UrlMultiInput/UrlMultiInput";
import { templateHelper } from "../helpers/templateHelper";
import {
  interactionTemplateSettings,
  templateSettings,
} from "../models/interactionTemplateSettings";
import CollapsePanel from "./CollapsePanel";
import FontPicker from "./FontPicker";
import { FontWeightPicker } from "./FontWeightPicker";
const SettingsList = (props) => {
  
  const handleUpdate = (template) => {
    const { dispatch } = props;
    dispatch(templateActions.softUpdate(template));
  };

  const handleChange = (v, path, attachedUnit) => {
    const { template } = props;
    if (Array.isArray(path)) {
      let templateCopy = deepClone(template);
      path.map((p) => {
        const names = p.split(".");

        let value = v;

        if (
          isNaN(value) &&
          (value.includes("http") || value.includes("base")) &&
          p.includes("background") &&
          !p.includes("backgroundUrl")
        )
          value = `url(${value}) 50% 50% / cover no-repeat fixed`;

        let unit = templateHelper.getUnit(templateCopy, names);
        if (!isNaN(value) && unit.length < 4) {
          value += attachedUnit || unit;
        }
        templateCopy.content = setValueToNestedObject(
          names,
          value,
          templateCopy.content
        );
      });
      handleUpdate(templateCopy);
    } else {
      const names = path.split(".");
      let templateCopy = deepClone(template);
      let value = v;
      let unit = templateHelper.getUnit(templateCopy, names);
      if (!isNaN(value) && unit.length < 4) {
        value += attachedUnit || unit;
      }
      templateCopy.content = deepClone(
        setValueToNestedObject(names, value, templateCopy.content)
      );
      handleUpdate(templateCopy);
    }
  };

  const handleUnitChange = (u, path) => {
    const { template } = props;

    const names = path.split(".");
    let unit = u;
    let templateCopy = deepClone(template);
    const value = templateHelper.getValueWithoutUnit(templateCopy, names);
    if (unit === "auto") unit = "auto";
    templateCopy.content = setValueToNestedObject(
      names,
      value + unit,
      templateCopy.content
    );
    handleUpdate(templateCopy);
  };

  const getSettings = (type) => {
    return !type
      ? templateSettings
      : interactionTemplateSettings.filter((it) => it.name == type);
  };

  const { template, type, directed = false, templateIsSavable } = props;
  if (template === undefined) return null;
  const groups = getSettings(type);
  if (!groups) return null;
  return (
    <div
      className={
        !type
          ? templateIsSavable
            ? "template-settings-wrapper short layout-list"
            : "template-settings-wrapper layout-list"
          : "template-settings-wrapper scoped layout-list"
      }
    >
      {groups.map((gm) => {
        return gm.settings.map((g, i) => {
          return (
            <React.Fragment key={i}>
              <CollapsePanel
                dark={true}
                open={g.open}
                name={g.group}
                icon={g.icon}
              >
                {!g.alert ? (
                  <React.Fragment>
                    {g.items.map((s, i2) => {
                      let v = templateHelper.getValue(
                        template,
                        `${s.path}.${s.name}`.split(".")
                      );
                      return (
                        <React.Fragment>
                          <div style={{ margin: "10px 0px" }} key={i2}>
                            <SettingsListItem
                              {...s}
                              value={v}
                              onUnitChange={(u) =>
                                handleUnitChange(u, `${s.path}.${s.name}`)
                              }
                              onChange={(value, extra = null) => {
                                handleChange(
                                  value,
                                  s.pathSpread || `${s.path}.${s.name}`,
                                  extra
                                );
                              }}
                            />
                          </div>
                          {s.separator ? <hr className="dark-l3" /> : null}
                        </React.Fragment>
                      );
                    })}
                  </React.Fragment>
                ) : (
                  <SystemLabel name={g.text} />
                )}
              </CollapsePanel>
            </React.Fragment>
          );
        });
      })}
    </div>
  );
};
function mapStateToProps(state) {
  return {
    template: state.template.template,
    templateIsSavable: state.template.isSavable,
  };
}
export default connect(mapStateToProps)(SettingsList);

export const SettingsListItem = ({
  type,
  label,
  path,
  value,
  onChange,
  onUnitChange,
  extra = null,
}) => {
  switch (type.toString().toUpperCase()) {
    case "SLIDER":
      return (
        <EditorSlider
          value={parseFloat(value || 0)}
          unparsedValue={value}
          defaultValue={extra.defaultValue}
          unitChange={onUnitChange}
          onChange={(s, v, p, ep) => onChange(parseFloat(v), ep)}
          units={extra.units ? extra.units : []}
          activeUnit={
            value != undefined && value != "unset" && value
              ? value.toString().replace(/[0-9/^d.-]/g, "")
              : ""
          }
          attachUnit={extra.units ? true : false}
          steps={extra.steps}
          max={extra.max}
          min={extra.min}
          path={""}
          dark={true}
          label={label}
        />
      );
    case "FONTFAMILY_SELECT":
      return (
        <FontPicker
          onChange={(s, font, p) => onChange(font)}
          path=""
          currentFontFamily={value}
        />
        /* <FontWeightPicker
                                    onChange={this.handleChange}
                                    path="interaction.client.agenda.row.active.title.fontWeight"
                                    currentFont={template.content.interaction.agenda.row.active.title.fontFamily}
                                    weight={template.content.interaction.agenda.row.active.title.fontWeight}
                                />
            */
      );
    case "FONTWEIGHT_SELECT":
      return (
        <FontWeightPicker
          onChange={(s, w, p) => onChange(w)}
          path=""
          weight={value}
        />
        /* <FontWeightPicker
                                      onChange={this.handleChange}
                                      path="interaction.client.agenda.row.active.title.fontWeight"
                                      currentFont={template.content.interaction.agenda.row.active.title.fontFamily}
                                      weight={template.content.interaction.agenda.row.active.title.fontWeight}
                                  />
              */
      );
    case "COLOR_PICKER":
      return (
        <Row>
          <Col className="text-left">
            <Label className="primary-text">
              <SystemLabel name={label} />
            </Label>
          </Col>
          <Col className="text-right">
            <ColorPickerFacade
              color={value}
              dark={true}
              onChange={(color, e) =>
                onChange(templateHelper.parseColorToRgba(color))
              }
              path=""
            />
          </Col>
        </Row>
      );
    case "SWITCH":
      return (
        <Row>
          <Col className="text-left">
            <Label className="primary-text">
              <SystemLabel name={label} />
            </Label>
          </Col>
          <Col className="text-right">
            <JirangoSwitch
              onChange={() => onChange(!value)}
              isChecked={value}
            />
          </Col>
        </Row>
      );
    case "BUTTON_GROUP":
      return (
        <FormGroup>
          <Label className="primary-text">
            <SystemLabel name={label} />
          </Label>
          <div className="btn-group">
            {extra.map((e, i) => {
              return (
                <div
                  className={"sq-btn" + (value == e.name ? " active" : "")}
                  onClick={() => onChange(e.name)}
                >
                  {e.icon}
                  <span>
                    <SystemLabel name={e.label} />
                  </span>
                </div>
              );
            })}
          </div>
        </FormGroup>
      );
    case "BUTTON_GROUP_SMALL":
      return (
        <div style={{ display: "flex" }}>
          <div style={{ textAlign: "left" }}>
            <Label className="primary-text">
              <SystemLabel name={label} />
            </Label>
          </div>
          <div style={{ marginLeft: "auto" }}>
            <ButtonGroup size="small" aria-label="small outlined button group">
              {extra.map((e, i) => {
                return (
                  <div
                    className={
                      "sq-btn small" + (value == e.name ? " active" : "")
                    }
                    onClick={() => onChange(e.name)}
                  >
                    {e.icon}
                  </div>
                );
              })}
            </ButtonGroup>
          </div>
        </div>
      );
    case "DATE":
      return (
        <FormGroup>
          <Label>
            <SystemLabel name={label} />
          </Label>
          <Input
            value={value}
            type="datetime-local"
            onChange={(e) => onChange(e.target.value)}
          />
        </FormGroup>
      );
    case "TEXT":
      return (
        <FormGroup className="dark-input">
          <Label className="primary-text">
            <SystemLabel name={label} />
          </Label>
          <Input
            value={value}
            type="text"
            onChange={(e) => onChange(e.target.value)}
          />
        </FormGroup>
      );
    case "MULTI_INPUT":
      return (
        <FormGroup className="dark-input dark-l1">
          {value.includes("http") ? (
            <div style={{ width: 287, height: 200, position: "relative" }}>
              <img
                style={{
                  cursor: "pointer",
                  maxWidth: "100%",
                  height: "auto",
                  maxHeight: "100%",
                  marginBottom: 10,
                  zIndex: 1,
                }}
                className="centered-text"
                src={value}
                onClick={() => onChange(value)}
              />
            </div>
          ) : null}
          <Label className="primary-text">
            <SystemLabel name={label} />
          </Label>
          <UrlMultiInput
            onChange={(url) => onChange(url)}
            setImage={(url) => onChange(url)}
            margin={false}
            noInfoText={true}
            dark={true}
            colStyle={{ padding: 0, margin: 0 }}
            rowStyle={{ margin: "0px" }}
            url={value && value.includes("http") ? value : ""}
          />
        </FormGroup>
      );
    /*     case "MULTI_INPUT":
      return (
        <FormGroup className="dark-input">
          <Label className="primary-text">
            <SystemLabel name={label} />
          </Label>
          <UrlMultiInput
            onChange={(url) => onChange(url)}
            setImage={(url) => onChange(url)}
            margin={false}
            noInfoText={true}
            dark={true}
            colStyle={{ padding: 0, margin: 0 }}
            rowStyle={{ margin: "0px" }}
            url={value}
          />
        </FormGroup>
      ); */
    /*     case "VIDEO_INPUT":
      return (
        <FormGroup className="dark-input">
          <Label className="primary-text">
            <SystemLabel name={label} />
          </Label>
          <InputGroup>
            <Input
              autoComplete="jirango-nofill"
              onChange={(e) => this.handleChange(null, e, "main.youtubeUrl")}
              value={value}
            />
            <InputGroupAddon onClick={this.handlePaste} addonType="append">
              <InputGroupText
                style={{ backgroundColor: "#fff", cursor: "pointer" }}
              >
                <i className="fa fa-paste" />
              </InputGroupText>
            </InputGroupAddon>
          </InputGroup>
          <p
            className="text-muted"
            style={{ lineHeight: "initial", marginTop: "5px" }}
          >
            <SystemLabel name="VideoLinkInstruction" />
          </p>
        </FormGroup>
      ); */
    case "NUMBER":
      return (
        <FormGroup className="dark-input">
          <Label className="primary-text">
            <SystemLabel name={label} />
          </Label>
          <Input
            value={parseFloat(value)}
            type="number"
            steps={extra.steps}
            max={extra.max}
            min={extra.min}
            onChange={(e) => onChange(e.target.value)}
          />
        </FormGroup>
      );
    default:
      return null;
  }
};
